/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { configuracaoModuleName, configuracaoRoute } from "../../../shared/services/data.service";
import {obrigacoesModuleName, obrigacoesRoute} from "../../obrigacoes/shared/data.service";
import {despachosRoute} from "../data.service";

@Component({
    selector: 'app-despacho-obrigacoes-menu',
    template: require('./despacho-obrigacoes-menu.component.html')
})
export class DespachoObrigacoesMenuComponent implements OnInit {
    despachosRoute: string = despachosRoute;
    obrigacoesRoute: string = obrigacoesRoute;
    configuracaoRoute: string = configuracaoRoute;

    obrigacoesModule: any = obrigacoesModuleName;
    configuracaoModule: any = configuracaoModuleName;

    constructor() { }

    ngOnInit() {
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/shared/despacho-obrigacoes-menu/despacho-obrigacoes-menu.component.ts
 **/